export default __webpack_public_path__ + "static/media/data.7d1ea6a9.mp4";